<template>
  <div class="card">
    <div
      v-if="item"
      :class="cardClass"
      @click="onClick"
      :style="isActive ? 'background-color: ' + primary : ''"
    >
      <div
        class="card-content__img"
        :style="{
          background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
        }"
      >
        <img :src="item.image" :alt="item.label" v-if="item.image" />
        <div
          class="lowest-price"
          v-if="getLowestPrice(item.Terms) && windowWidth < 640"
        >
          <p>
            Starts from
            <strong>{{ formatPrice(getLowestPrice(item.Terms)) }}</strong>
          </p>
        </div>
      </div>
      <div
        class="card-body"
        :style="{
          maxWidth: windowWidth < 640 ? `${windowWidth - 88}px` : null
        }"
      >
        <span v-if="item.label" class="card-content__title">
          {{ item.label }}
        </span>
        <div class="card-content__subtitle">
          <div
            v-if="item.Location.name"
            class="text-wrap"
            :title="item.Location.name"
          >
            <span class="text-wrap__content card-content__location">
              {{ item.Location.name }}
            </span>
          </div>
          <div
            v-if="item.Category.name"
            class="text-wrap"
            :title="item.Category.name"
          >
            <span class="text-wrap__content card-content__category">
              {{ item.Category.name }}
            </span>
          </div>
          <div
            v-if="item.MetaDatum && item.MetaDatum.value > 0"
            class="card-content__capacity"
          >
            <icon-base style="height: 1rem; width: 1rem; margin-top: -.25rem">
              <IconPeople />
            </icon-base>
            <span>{{
              `${item.MetaDatum.value} Seat${
                item.MetaDatum.value > 1 ? "s" : ""
              }`
            }}</span>
          </div>
        </div>
      </div>
      <div class="card-footer" v-if="windowWidth >= 640">
        <div v-if="item.Terms.length" class="card-content__price">
          <div
            class="card-content__rate"
            v-for="term in item.Terms"
            :key="`term-${term.id}`"
          >
            <strong>{{ formatPrice(term.Package.price) }}</strong>
            /
            {{ term.name.toLowerCase() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconPeople from "@/components/icons/IconPeople";

export default {
  name: "Card",
  components: {
    IconPeople
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    active: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    cardClass() {
      return this.active === this.item.id
        ? "card-content card-content__active"
        : "card-content";
    },
    isActive() {
      return this.active === this.item.id;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    currency() {
      return "P";
    },
    terms() {
      return this.item.Terms.filter(item => item.status === 2).slice(0, 2);
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {
    onClick() {
      this.$emit("response", {
        productId: this.item.id,
        locationId: this.item.locationId,
        item: this.item
      });
    },
    formatPrice(price, decimal = false) {
      return `${this.currency} ${price.toLocaleString("en-US", {
        minimumFractionDigits: decimal && 2,
        maximumFractionDigits: 2
      })}`;
    },
    getLowestPrice(terms) {
      const validTerms = terms.filter(t => t.Package);

      return validTerms.reduce((acc, curr) =>
        acc.Package.price < curr.Package.price ? acc : curr
      ).Package.price;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex: 100%;
  flex-flow: column wrap;
  margin-bottom: 1.875rem;
  padding-left: 2.25rem;
  padding-right: 2.25rem;

  @media (min-width: 640px) {
    flex: 0 0 50%;
    padding-left: 0.78125rem;
    padding-right: 0.78125rem;
  }

  @media (min-width: 992px) {
    flex: 0 0 25%;
  }

  @media screen and (max-width: 639px) {
    overflow: hidden;
    justify-content: center;
  }

  &-content {
    border-radius: 8px;
    box-shadow: 0 3px 15px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    flex-flow: column wrap;
    height: 100%;
    transition: background 200ms ease;
    width: 100%;

    @media screen and (max-width: 639px) {
      overflow: hidden;
    }

    &:hover img {
      transform: scale(1.05);
    }

    &__img {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      height: 11.25rem;
      overflow: hidden;
      width: 100%;
      position: relative;

      img {
        width: 100%;
        object-fit: cover;
        height: 100%;
        transition: transform 200ms ease;
      }

      .lowest-price {
        position: absolute;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        background-color: #232323;
        border-radius: 4px;
        right: 8px;
        bottom: 8px;
        p {
          font-family: "Nunito Sans";
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #ffffff;
          margin: 0;

          strong {
            font-weight: 700;
          }
        }
      }
    }
    &__title {
      font-family: $headings-font-family;
      font-size: 1rem;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 0.5rem;
      color: #232323;

      @media screen and (max-width: 639px) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &__active {
      background-color: $gray-500;
      color: white;
    }
    &__active &__subtitle {
      color: #fff;
    }

    &__subtitle {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      .card-content__capacity {
        display: flex;
        align-items: center;

        svg {
          margin-right: 4px;
        }

        span {
          width: max-content;
        }
      }

      @media screen and (min-width: 640px) {
        flex-direction: column;
        align-items: unset;
      }

      @media screen and (max-width: 639px) {
        flex-wrap: nowrap;
        overflow: hidden;

        .text-wrap {
          flex: 0 1 auto;
          overflow: hidden;

          &:not(:first-child)::before {
            content: "\2B24";
            font-size: 4px;
            padding: 0 4px;
            margin-top: 8px;
            color: #949494;
          }

          span {
            width: min-content;
            flex: unset;
            margin: 0;
          }
        }

        .card-content__capacity {
          &:not(:first-child)::before {
            content: "\2B24";
            font-size: 4px;
            padding: 0 4px;
            color: #949494;
          }
        }
      }
    }

    &__location {
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: #4c4c4c;
      margin-bottom: 0.25rem;
    }
    &__category {
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: #4c4c4c;
      margin-bottom: 0.25rem;
    }
    &__capacity {
      font-size: 0.875rem;
      color: #4c4c4c;
    }
    &__rate {
      font-size: 0.875rem;
      color: #4c4c4c;
    }

    strong {
      font-weight: 500;
    }
  }

  &-body {
    padding: 1.0625rem 1rem 1.5rem;

    @media screen and (max-width: 639px) {
      overflow: hidden;
      display: flex;
      flex-flow: column nowrap;
    }
  }

  &-footer {
    padding: 0 1rem 1rem;
  }
}
</style>
